import { argumentsObjectFromField } from './storeUtils';
export function getDirectiveInfoFromField(field, variables) {
  if (field.directives && field.directives.length) {
    var directiveObj_1 = {};
    field.directives.forEach(function (directive) {
      directiveObj_1[directive.name.value] = argumentsObjectFromField(directive, variables);
    });
    return directiveObj_1;
  }

  return null;
}
export function shouldInclude(selection, variables) {
  if (variables === void 0) {
    variables = {};
  }

  if (!selection.directives) {
    return true;
  }

  var res = true;
  selection.directives.forEach(function (directive) {
    if (directive.name.value !== 'skip' && directive.name.value !== 'include') {
      return;
    }

    var directiveArguments = directive.arguments || [];
    var directiveName = directive.name.value;

    if (directiveArguments.length !== 1) {
      throw new Error("Incorrect number of arguments for the @" + directiveName + " directive.");
    }

    var ifArgument = directiveArguments[0];

    if (!ifArgument.name || ifArgument.name.value !== 'if') {
      throw new Error("Invalid argument for the @" + directiveName + " directive.");
    }

    var ifValue = directiveArguments[0].value;
    var evaledValue = false;

    if (!ifValue || ifValue.kind !== 'BooleanValue') {
      if (ifValue.kind !== 'Variable') {
        throw new Error("Argument for the @" + directiveName + " directive must be a variable or a boolean value.");
      } else {
        evaledValue = variables[ifValue.name.value];

        if (evaledValue === undefined) {
          throw new Error("Invalid variable referenced in @" + directiveName + " directive.");
        }
      }
    } else {
      evaledValue = ifValue.value;
    }

    if (directiveName === 'skip') {
      evaledValue = !evaledValue;
    }

    if (!evaledValue) {
      res = false;
    }
  });
  return res;
}
export function flattenSelections(selection) {
  if (!selection.selectionSet || !(selection.selectionSet.selections.length > 0)) return [selection];
  return [selection].concat(selection.selectionSet.selections.map(function (selectionNode) {
    return [selectionNode].concat(flattenSelections(selectionNode));
  }).reduce(function (selections, selected) {
    return selections.concat(selected);
  }, []));
}
export function getDirectiveNames(doc) {
  var directiveNames = doc.definitions.filter(function (definition) {
    return definition.selectionSet && definition.selectionSet.selections;
  }).map(function (x) {
    return flattenSelections(x);
  }).reduce(function (selections, selected) {
    return selections.concat(selected);
  }, []).filter(function (selection) {
    return selection.directives && selection.directives.length > 0;
  }).map(function (selection) {
    return selection.directives;
  }).reduce(function (directives, directive) {
    return directives.concat(directive);
  }, []).map(function (directive) {
    return directive.name.value;
  });
  return directiveNames;
}
export function hasDirectives(names, doc) {
  return getDirectiveNames(doc).some(function (name) {
    return names.indexOf(name) > -1;
  });
}